import { findThanksgivingWeek } from "./dateHelpers"

export const SEMESTER_DATES = [
  ["2016 A", "2016/01/01"],
  ["2016 B", "2016/06/01"],
  ["2016 C", "2016/09/01"],
  ["2017 A", "2017/01/01"],
  ["2017 B", "2017/06/01"],
  ["2017 C", "2017/09/01"],
  ["2018 A", "2018/01/01"],
  ["2018 B", "2018/06/01"],
  ["2018 C", "2018/09/02"],
  ["2019 A", "2019/01/01"],
  ["2019 B", "2019/05/02"],
  ["2019 C", "2019/09/02"],
  ["2020 A", "2020/01/01"],
  ["2020 B", "2020/06/08"],
  ["2020 C", "2020/08/09"],
  ["2021 A", "2021/01/04"],
  ["2021 B", "2021/06/07"],
  ["2021 C", "2021/08/08"],
  ["2022 A", "2021/12/20"],
  ["2022 B", "2022/06/06"],
  ["2022 C", "2022/08/15"],
  ["2023 A", "2022/12/19"],
  ["2023 B", "2023/06/12"],
  ["2023 C", "2023/08/14"],
  ["2024 A", "2024/01/08"],
  ["2024 B", "2024/06/10"],
  ["2024 C", "2024/08/12"],
  ["2025 A", "2024/12/23"],
  ["2025 B", "2025/06/09"],
  ["2025 C", "2025/08/11"],

  // FILL THESE IN
  ["2026 A", "2026/01/05"],
  ["2026 B", "2026/06/08"],
  ["2026 C", "2026/08/10"],
  ["2027 A", "2027/01/04"],
] as const

// Currently just thanksgiving week
const getSkipDays = (): string[] => {
  const skipDays = []
  const nextYear = new Date().getFullYear() + 1

  for (let year = 2016; year <= nextYear; year++) {
    const thanksgivingWeek = findThanksgivingWeek(year)

    for (const day of thanksgivingWeek) {
      skipDays.push(day)
    }
  }

  return skipDays
}

export const SKIP_DAYS = getSkipDays()
